
import React, { useMemo, useState } from "react";
import AdminPublishTable from "./components/AdminPublishTable";

import AdminSidebar from "./components/AdminSidebar";
import Header from "units/dashboard/components/Header";
import Footer from "units/dashboard/components/Footer";


export default function AdminPublishList() {
    const [statusCounts, setStatusCounts] = useState({
        "تایید شده": 0,
        "در انتظار": 0,
        "عدم تایید": 0,
        "ثبت اولیه": 0
    });

    const handleStatusCountsChange = (counts) => {
        if (counts && typeof counts === "object") {
            setStatusCounts(counts);
        }
    };
    const bot = useMemo(() => [
        { title: "تایید شده", count:statusCounts["تایید شده"]?? 0, color: "bg-green-500", textColor: "text-white" },
        { title: "در انتظار تایید ", count:statusCounts["در انتظار"]?? 0, color: "bg-gray-400", textColor: "text-white" },
        { title: "تایید نشده", count:statusCounts["عدم تایید"]?? 0, color: "bg-red-500", textColor: "text-white" },
        { title: "ثبت اولیه", count:statusCounts["ثبت اولیه"]?? 0, color: "bg-[#FFC505]", textColor: "text-white" }

    ], [statusCounts]);
    return (
        <>

            <nav
                className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                <Header />
            </nav>

            <div
                className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                <AdminSidebar />
            </div>

            <div className="flex flex-col min-h-screen">
                <div className="main-content flex-grow pt-16 pb-12">
                    <div className="col-span-12  xl:col-span-6 xl:p-6  min-h-screen rtl items-center justify-center pb-5">

                        <div className="card-body pb-0 bg-white shadow-sm rounded-lg p-6">
                            <h4 className="mb-4 text-lg font-semibold text-gray-800 dark:text-gray-100">
                                فهرست بات‌های درخواستی
                            </h4>
                            <p className="text-gray-600 dark:text-gray-300 pb-4">
                                در این بخش می‌توانید وضعیت هر یک از بات‌های درخواستی را تغییر دهید.
                            </p>
                        </div>
                        <div className="max-w-[850px] m-auto flex justify-center items-center flex-wrap gap-2 gap-x-1 md:gap-x-8 mt-10 pr-2 ">

                            {bot.map((acc, index) => (
                                <div
                                    key={index}
                                    className={`flex flex-col items-center justify-center shadow-lg rounded-xl ${acc.color} text-right px-5 py-2 w-[150px]  md:w-[200px]`}

                                >
                                    <h2 className={`text-sm md:text-l font-semibold ${acc.textColor} text-center `}>{acc.title}</h2>
                                    <p className="text-md font-bold mt-2 text-white">{acc.count} عدد</p>
                                </div>

                            ))}
                        </div>



                        <AdminPublishTable  onStatusCountsChange={handleStatusCountsChange}/>
                    </div >
                    <Footer />
                </div>
            </div>
        </>

    );
}




